<template>
  <div class='driver-item-carrier-list deviceList border-box' :style='{ height: height }'
       style='border-top:solid 1px #ccc'>
    <div class='uk-flex uk-flex-middle' style='padding: 0px 0 5px 0;margin-right: 3px;border-bottom: solid 1px #ccc;'>
      <div>
        <el-checkbox @change='toggleSelect' class='allcheck' :indeterminate='checkbox.indeterminate'
                     v-model='checkbox.checked'></el-checkbox>
      </div>

      <div>
        <div class='uk-flex uk-flex-middle filter'>
          <!-- 监测点类型选择 -->
          <el-select v-model='filter.pointType' :placeholder="$t('please')">
            <el-option :label="$t('public.carrier_type')" :value='null'></el-option>
            <el-option v-for='item in carrierType' :key='item.id' :label='item.name' :value='item.id'>
              <i :class='carrierTypeConvert(item.id).icon'></i>
              <span class='uk-margin-small-left'>{{ getLanguage() === 'zh_CN' ?item.name : item.code}}</span>
            </el-option>
          </el-select>

          <div style='width:10px'></div>
          <!-- 监测点状态选择 -->
          <el-select v-model='filter.pointStatus' :placeholder="$t('please')">
            <el-option :label="$t('public.carrier_status')" :value='null'></el-option>
            <el-option v-for='item in carrierStatus' :key='item.id' :label='$t(item.name)' :value='item.code'>
              <i :class='carrierStatusConvert(item.code).icon'></i>
              <span class='uk-margin-small-left'>{{ getLanguage() === 'zh_CN' ?item.name : item.content }}</span>
            </el-option>
          </el-select>
        </div>
        <div>
          <div class='uk-flex'>
            <el-input v-model='filter.text'
                      :placeholder="$t('integration.please_enter_the_name_of_the_monitoring_point')"></el-input>
            <el-button type='primary' icon='el-icon-search' class='btnClass' @click='searchDevie'></el-button>
          </div>
        </div>
      </div>
    </div>

    <el-table
      v-loading='loading'
      ref='multipleTable'
      row-key='id'
      :data='carrierList'
      tooltip-effect='dark'
      style='width: 100%;overflow-x: hidden;'
      :show-header='false'
      stripe
      :height='tableHeight'
      @select='handleSelectRow'
      v-load-more.expand="{
                func: loadMore,
                target: '.el-table__body-wrapper',
                delay: 100
            }"
      :load-more-disabled='disabledLoad'
    >
      <el-table-column :reserve-selection='true' type='selection' width='18' />
      <el-table-column prop='name' width='220'>
        <template #default='{ row }'>
          <div class='ellipsis uk-text-nowrap'>
            <i v-icon:theme="['carrierTypeConvert', row.typeId]" style='margin-right:5px'></i>
            <i v-icon:theme="['carrierStatusConvert', row.status]" style='margin-right:5px'></i>
            <i v-icon:theme="['isAbnormalConvert', row.abnormal]" style='margin-right:5px'></i>
            <i v-icon:theme="['traceConvert', row.isTrace]" style='margin-right:5px'></i>
            <el-tooltip effect='dark' :content='row.keycode' placement='top' class='ellipsis'>
              <span>{{ row.keycode }}</span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop='optare' align='center'>
        <template #default='{ row }'>
          <el-button type='text' icon='el-icon-tickets' :title="$t('public.details')"
                     @click='detailFn(row)'></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-button class="position-relative width-100" style="bottom:0;"  @click="loadMore">{{$t("点击查看更多")}}</el-button> -->
  </div>
</template>

<script>
import bus from '@/utils/bus.js'
import { carrierStatusConvert, carrierTypeConvert, isAbnormalConvert, traceConvert } from '@/utils/convert'
import { carrierDetail } from '@/utils/winDetail'
import { _debounce } from '@/utils/common'
import { getCarrierType, shareParam } from '@/api/modules/public'
import { getLanguage } from '@/lang'

export default {
  props: ['loading', 'carrierList', 'page', 'saved', 'params', 'height', 'disabledLoad'],
  watch: {
    carrierList (newVal) {
      this.$refs.multipleTable.clearSelection()
      this.checkbox = {
        indeterminate: false,
        checked: false
      }
      this.handleSaved()
    },
    saved () {
      // this.handleSaved();
    }
  },
  data () {
    return {
      carrierTypeConvert,
      carrierStatusConvert,
      isAbnormalConvert,
      traceConvert,
      tableHeight: 'calc(100% - 77px)',
      // 表格的数据
      tableData: [],
      filter: {
        // 监测点状态
        pointStatus: null,
        // 监测点类型
        pointType: null,
        // 过滤点名称文本
        text: ''
      },
      checkbox: {
        indeterminate: false,
        checked: false
      },
      // 用于多选时 进行防抖
      selectRow: null,
      // 选中的监测点  这个数据需要做缓存 发送到右侧
      saveList: [],
      carrierType: [],
      carrierStatus: [],
      getLanguage
    }
  },
  mounted () {
    // 监测点类型下拉框
    this.getCarrierType()
    // 监测点状态下拉框
    this.getCarrierStatus()

    bus.$on('cancelSelect', id => {
      const item = this.carrierList.filter(item => item.id == id)

      // 将取消选中的点去除 维护一个saved   做到发送到右边的数据接收就能直接使用
      const saved = this.saved.filter(item => (item.carrierId || item.id) != id)
      this.$emit('update:saved', saved)
      if (!item.length) return
      this.$refs.multipleTable.toggleRowSelection(...item, false)

      this.$nextTick(() => {
        // 更新顶部复选框的选择状态
        this.selectRowFn(this.$refs.multipleTable.selection, null, false)
      })
    })

    // 进行防抖处理
    this.selectRow = _debounce(this.selectRowFn, 100)
  },
  beforeDestroy () {
    bus.$off('cancelSelect')
  },
  methods: {
    selectChange (selection, row) {
      // console.log(selection,row);
    },
    // 获取监测点类型下拉框
    getCarrierType () {
      getCarrierType().then(({ result }) => {
        this.carrierType = result
      })
    },
    // 获取监测点状态下拉框
    getCarrierStatus () {
      shareParam({
        code: 'carrier_status_item',
        type: 0
      }).then(({ result }) => {
        this.carrierStatus = result
      })
    },
    detailFn (row) {
      const {
        id,
        keycode,
        typeId
      } = row
      carrierDetail(id, keycode, typeId)
    },
    handleSelectRow (rows, row, isEmit) {
      this.selectRow(rows, row, isEmit)
    },
    selectRowFn (rows, row, isEmit = true) {
      // rows-当前选中的所有行  row-当前点击的行
      // 是半选还是全选
      const checkedCount = rows.length
      // 全选
      const checkAll = checkedCount === this.carrierList.length
      // 半选
      const isIndeterminate = checkedCount > 0 && checkedCount < this.carrierList.length
      this.checkbox.indeterminate = isIndeterminate
      this.checkbox.checked = checkAll
      this.checkbox.isTableOpt = true
      this.$emit('handleSelect', {
        isIndeterminate,
        checkAll
      })

      this.$nextTick(() => {
        // 这部分需要做到传过去的数据是直接能用的 过滤出不在保存列表中的

        // 保留ID
        const checked = this.saved.map(item => item.id || item.carrierId)
        // 过滤出不在保存列表中的， 往后追加
        const add = rows.filter(item => checked.indexOf(item.id || item.carrierId) === -1)
        // 过滤出需要删除的项
        const unChecked = this.carrierList.filter(item => rows.findIndex(row => row.id === item.id) === -1)
        // console.log(unChecked);
        // 选中项的ID格式化
        const rowsChecked = rows.map(item => item.id || item.carrierId).concat(checked)
        // 不在CarrierList 和 saveList 中的项即被过滤
        const del = this.saved
          .filter(item => rowsChecked.indexOf(item.id || item.carrierId) === -1)
          .concat(unChecked)
          .map(item => item.id || item.carrierId)

        // 删除项后 往后追加需要添加的项
        const saved = this.saved.filter(item => del.indexOf(item.id || item.carrierId) === -1).concat(add)
        this.$emit('update:saved', saved)

        if (isEmit) {
          this.$nextTick(() => {
            bus.$emit('selectRows', saved)
          })
        }
      })
    },
    searchDevie () {
      const params = {
        ...this.params,
        carrierType: this.filter.pointType || null,
        carrierName: this.filter.text || null,
        status: this.filter.pointStatus || null
      }

      this.$emit('update:params', params)
      this.$emit('update:page', 0)
      this.$emit('search')
    },
    toggleSelect () {
      if (this.checkbox.checked) {
        this.carrierList.forEach(item => {
          this.$refs.multipleTable.toggleRowSelection(item, true)
          this.handleSelectRow(this.carrierList)
        })
        // 触发全选
        // bus.$emit("selectRows",this.carrierList);
      } else {
        this.$refs.multipleTable.clearSelection()
        // 触发全不选
        // bus.$emit("selectRows",this.saved);
        this.handleSelectRow([])
      }
    },
    // 加载更多
    loadMore () {
      this.$emit('loadMore')
    },
    // 处理选中 将选中的点全部选中
    handleSaved () {
      if (this.saved && this.saved.length && this.carrierList.length) {
        const checked = this.saved.map(item => item.id || item.carrierId)
        this.carrierList.forEach(item => {
          if (checked.indexOf(item.id) !== -1) {
            this.$refs.multipleTable.toggleRowSelection(item, true)
          }
        })
        this.handleSelectRow(this.$refs.multipleTable.selection, undefined, false)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.allcheck {
  margin: 0 2px;
  margin-right: 5px;
}

.deviceList {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0 2px;
  box-sizing: border-box;
  // border-bottom: 1px solid $borderColor3;
  overflow: hidden;

  .filter {
    padding: 5px 0;
  }

  ::v-deep .el-table-column--selection .cell {
    padding-left: 0;
  }
}

// 隐藏table的横向滚动条
::v-deep .el-table__body-wrapper {
  overflow-x: hidden;
}

// 隐藏原生checkbox
::v-deep .el-checkbox__original {
  display: none;
}
</style>
